import React from 'react';

export default function ProjectsAndApprovalsView({ activeView, onNavigate, onOpenModal, onShowToast }) {
  return (
    <>
        <div id="view-projects" className={`view-panel ${activeView === 'view-projects' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-cubes" style={{"color":"var(--gold-light)"}}></i> QUẢN TRỊ 4 DỰ ÁN TRỌNG ĐIỂM</h2>
                    <p>Theo Dõi Tiến Độ, Milestone, Deadline, Ngân Sách Token &amp; Bàn Giao Đầu Ra</p>
                </div>
                <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
            </div>
            <div style={{"display":"grid","gridTemplateColumns":"1fr 1fr","gap":"14px"}}>
                <div className="workflow-step-card">
                    <div style={{"display":"flex","justifyContent":"space-between","marginBottom":"8px"}}>
                        <span style={{"fontFamily":"monospace","color":"var(--gold-light)","fontWeight":"700"}}>PRJ-TTP</span>
                        <span style={{"color":"var(--green)","fontWeight":"700"}}>78% (On Track)</span>
                    </div>
                    <h3 style={{"color":"white","fontSize":"15px"}}>Thế Thảo Pharma — Phân Phối Dược Phẩm</h3>
                    <p style={{"color":"var(--text-muted)","fontSize":"12px","margin":"6px 0"}}>Owner: <strong>Anh Thế</strong> • Deadline: <strong>30/09/2026</strong> • 12 Tasks</p>
                </div>
                <div className="workflow-step-card">
                    <div style={{"display":"flex","justifyContent":"space-between","marginBottom":"8px"}}>
                        <span style={{"fontFamily":"monospace","color":"var(--blue-light)","fontWeight":"700"}}>PRJ-TOP</span>
                        <span style={{"color":"var(--blue-light)","fontWeight":"700"}}>64% (Reviewing)</span>
                    </div>
                    <h3 style={{"color":"white","fontSize":"15px"}}>TopPharma — E-commerce B2B Dược</h3>
                    <p style={{"color":"var(--text-muted)","fontSize":"12px","margin":"6px 0"}}>Owner: <strong>Chị Thảo</strong> • Deadline: <strong>15/10/2026</strong> • 9 Tasks</p>
                </div>
            </div>
        </div>

        <div id="view-approvals" className={`view-panel ${activeView === 'view-approvals' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-signature" style={{"color":"var(--gold-light)"}}></i> HÀNG ĐỢI PHÊ DUYỆT CẤP ĐIỀU HÀNH (BOD)</h2>
                    <p>Kiểm Tra Bằng Chứng, Đối Soát Dữ Liệu &amp; Bấm 1-Click Duyệt / Yêu Cầu Sửa / Từ Chối</p>
                </div>
                <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
            </div>
            <div style={{"display":"flex","flexDirection":"column","gap":"12px"}}>
                <div className="workflow-step-card" style={{"borderLeft":"3px solid var(--gold)"}}>
                    <div style={{"display":"flex","justifyContent":"space-between"}}>
                        <strong style={{"color":"white","fontSize":"14px"}}>1. Phê duyệt ngân sách Video Marketing PRJ-TTP: 5.000.000 đ</strong>
                        <span style={{"color":"var(--gold)","fontWeight":"700"}}>Chờ Duyệt BOD</span>
                    </div>
                    <p style={{"color":"var(--text-muted)","fontSize":"12px","margin":"8px 0"}}>10 Video ngắn Reels/TikTok, cam kết tiếp cận 25.000 lượt xem nhà thuốc.</p>
                    <div style={{"display":"flex","gap":"8px","justifyContent":"flex-end"}}>
                        <button className="btn-quick" style={{"width":"auto"}} onClick={() => onShowToast('Yêu cầu chỉnh sửa!')}>Yêu cầu sửa</button>
                        <button className="btn-quick primary" style={{"width":"auto"}} onClick={() => onShowToast('ĐÃ DUYỆT NGÂN SÁCH!')}>Phê duyệt 1-Click</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="view-risks" className={`view-panel ${activeView === 'view-risks' ? 'active' : ''}`}>
            <div className="dept-header-banner">
                <div className="dept-title-box">
                    <h2><i className="fa-solid fa-triangle-exclamation" style={{"color":"var(--red)"}}></i> TRUNG TÂM PHỤ THUỘC &amp; CẢNH BÁO RỦI RO</h2>
                    <p>Giám Sát Ma Trận SLA Liên Phòng Ban &amp; Điểm Nghẽn Vận Hành</p>
                </div>
                <button className="btn-quick" onClick={() => onNavigate('view-cockpit')}><i className="fa-solid fa-arrow-left"></i> Về Cockpit</button>
            </div>
            <div className="workflow-step-card">
                <h3 style={{"color":"white","fontSize":"14px","marginBottom":"8px"}}>Ma Trận Phụ Thuộc Liên Phòng Ban (SLA Matrix)</h3>
                <div style={{"display":"flex","flexDirection":"column","gap":"8px","fontSize":"12px"}}>
                    <div style={{"padding":"10px","background":"var(--bg-card-inner)","borderRadius":"var(--radius-sm)","display":"flex","justifyContent":"space-between"}}>
                        <span>Marketing <i className="fa-solid fa-arrow-right" style={{"color":"var(--gold)","margin":"0 6px"}}></i> Kho Vận (Tồn kho chothuoc247.vn)</span>
                        <span style={{"color":"var(--green)","fontWeight":"700"}}>SLA 15 phút (Đạt 100%)</span>
                    </div>
                    <div style={{"padding":"10px","background":"var(--bg-card-inner)","borderRadius":"var(--radius-sm)","display":"flex","justifyContent":"space-between"}}>
                        <span>Kế Toán <i className="fa-solid fa-arrow-right" style={{"color":"var(--gold)","margin":"0 6px"}}></i> Thu Mua (Bảng tách HĐ VAT)</span>
                        <span style={{"color":"var(--green)","fontWeight":"700"}}>SLA 30 phút (Đạt 100%)</span>
                    </div>
                </div>
            </div>
        </div>

    </>
  );
}
